import React from "react";
import { Container } from "@mui/system";
import styles from "./Faq.module.css";
import AppStackLayout from "component/AppStackLayout/AppStackLayout";
import FaqContent from "component/Modules/faq/FaqContent";

function Faq() {
  return (
    <AppStackLayout activeLink="faq">
      <div className={styles.faq}>
        <Container maxWidth="md">
          <div className={styles.faq_content}>
            <FaqContent type='faq_page' />
          </div>
        </Container>
      </div>
    </AppStackLayout>
  );
}

export default Faq;
